import React, { useState, useEffect } from 'react';
import QuizInline from './QuizInline';
import styles from './VideoAccordion.module.css';

export default function VideoAccordion({ video, quiz, disabled = false }) {
  const [open, setOpen] = useState(false);
  const [annotations, setAnnotations] = useState([]);
  const [showQuiz, setShowQuiz] = useState(false);

  useEffect(() => {
    if (!open || disabled) {
      setShowQuiz(false);
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/videos/${video.id}/annotations`, {
      credentials: 'include'
    })
      .then(r => r.json())
      .then(setAnnotations)
      .catch(console.error);
  }, [open, video.id, disabled]);

  return (
    <div className={styles.accordion}>
      <button
        className={styles.header}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span className={styles.icon}>{open ? '−' : '+'}</span>
        <span className={styles.title}>{video.title}</span>
      </button>

      {open && (
        <div className={styles.body}>
          {disabled ? (
            <p className={styles.locked}>
              Contenido bloqueado. Obtén acceso para ver el video y el cuestionario.
            </p>
          ) : (
            <>
              <div className={styles.player}>
                <iframe
                  title={video.title}
                  src={video.url}
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                />
              </div>

              {annotations.length > 0 && (
                <div className={styles.annotations}>
                  <h5>Anotaciones</h5>
                  <ul>
                    {annotations.map((a, i) => (
                      <li key={i}>
                        <strong>{a.time}</strong>: {a.text}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {showQuiz && <QuizInline questions={quiz.questions} />}
            </>
          )}
        </div>
      )}
    </div>
  );
}
